import React from 'react'

import Grid from '../../../../components/pdf/Grid'
import Image from '../../../../components/pdf/Image'
import Separator from '../../../../components/pdf/Separator'
import Text from '../../../../components/pdf/Text'

const Header = () => {
  return (
    <>
      <Grid justify="left" align="left">
        <Image src="/pdfs/tembici/tembici_logo.png" maxWidth={150} ignoreFixedSize />
      </Grid>
      <Separator weight={0} />
      <Grid justify="center" align="center">
        <Text bold size={14}>
          AUTORIZAÇÃO PARA DESCONTO EM FOLHA DE PAGAMENTO
        </Text>
      </Grid>
      <Separator weight={2} />
    </>
  )
}

export default Header
